import styled from "styled-components";
import { colors, types } from "../../../libs";

export const Container = styled.div`
  width: 100%;
`;

export const Header = styled.div`
  align-items: flex-end;
  display: flex;
  gap: 24px;
  justify-content: space-between;

  @media (max-width: 700px) {
    align-items: stretch;
    flex-direction: column;
  }
`;

export const Title = styled.h1`
  ${types.headers.secondary};
  background: ${colors.text.textGradient};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0;
`;

export const Description = styled.p`
  color: ${colors.text.gray};
  margin: 8px 0 0;
`;

export const SearchWrapper = styled.div`
  align-items: center;
  display: flex;
  max-width: 340px;
  position: relative;
  width: 100%;

  > svg {
    color: ${colors.text.gray};
    left: 14px;
    position: absolute;
  }
`;

export const SearchInput = styled.input`
  background: ${colors.background.formField};
  border: 1px solid ${colors.background.lightWhite};
  border-radius: 20px;
  color: ${colors.text.white};
  padding: 9px 14px 9px 40px;
  width: 100%;

  &:focus {
    border-color: ${colors.text.green};
    outline: none;
  }
`;

export const TableWrapper = styled.div`
  border: 1px solid ${colors.background.lightWhite};
  border-radius: 8px;
  margin-top: 24px;
  overflow-x: auto;
`;

export const Table = styled.table`
  background: ${colors.background.black};
  border-collapse: collapse;
  color: ${colors.text.mediumWhite};
  min-width: 980px;
  width: 100%;

  th,
  td {
    border-bottom: 1px solid ${colors.background.lightWhite};
    padding: 14px 16px;
    text-align: left;
  }

  th {
    background: ${colors.background.lightBlack};
    color: ${colors.text.white};
  }

  tbody tr:last-child td {
    border-bottom: 0;
  }

  a {
    color: ${colors.text.green};
  }
`;

export const Status = styled.span<{ $sent: boolean }>`
  background: ${({ $sent }) => ($sent ? "rgba(183, 248, 77, 0.12)" : colors.background.lightWhite)};
  border-radius: 999px;
  color: ${({ $sent }) => ($sent ? colors.text.green : colors.text.mediumWhite)};
  display: inline-block;
  font-size: 12px;
  padding: 4px 9px;
`;

export const ViewButton = styled.button`
  background: transparent;
  border: 0;
  color: ${colors.text.green};
  padding: 0;
  text-decoration: underline;
`;

export const EmptyCell = styled.td`
  color: ${colors.text.gray};
  padding: 32px !important;
  text-align: center !important;
`;

export const LoadMoreWrapper = styled.div`
  margin: 16px auto 0;
  max-width: 180px;
`;

export const ModalContent = styled.div`
  background: ${colors.background.lightBlack};
  color: ${colors.text.mediumWhite};
  padding: 24px;
`;

export const ModalHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;

  h3 {
    margin: 0;
  }
`;

export const CloseButton = styled.button`
  background: transparent;
  border: 0;
  color: ${colors.text.white};
`;

export const SubmittedAt = styled.p`
  color: ${colors.text.gray};
  margin: 6px 0 20px;
`;

export const DetailList = styled.dl`
  display: grid;
  gap: 10px 18px;
  grid-template-columns: minmax(150px, 0.35fr) 1fr;
  margin: 0;

  dt {
    color: ${colors.text.gray};
  }

  dd {
    margin: 0;
    overflow-wrap: anywhere;
    white-space: pre-wrap;
  }

  @media (max-width: 575px) {
    grid-template-columns: 1fr;
  }
`;
